import StoredLayout from '../../layouts/StoredLayout'
import ECommerce from './ECommerce'
export default StoredLayout(ECommerce)



// WEBPACK FOOTER //
// ./src/dashboards/e-commerce/index.js